import axios from "axios";
import { API_ENDPOINTS, API_URL, SUPER_ADMIN_API_ENDPOINTS, SUPER_ADMIN_API_URL } from "../../constants";
import axiosInstance from "../../core/apiService/webApiService";
import superAdminAxiosInstance from "../../core/apiService/superAdminApiService";

//api call to fetch users list with search
const fetchActiveAccountsData = async (
  {
    searchquery ="",
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBER_LISTS.FETCH_NON_MEMBERS}?search=${searchquery}&UserType=member&ApprovalStatus=APPROVED&IsActiveMmPlan=true`,
    config
  )
   console.log(response,"fetchActiveAccountsListData")
  return response.data;
};

const fetchInactiveAccountsData = async (
  {
    searchquery ="",
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBER_LISTS.FETCH_MEMBERS}?search=${searchquery}&UserType=member&ApprovalStatus=REJECTED&IsActiveMmPlan=false`,
    config
  )
  return response.data;
};

const fetchDeletedAccountsData = async (
  {
    searchquery ="",
    pageNumber,
    alphabet,
    groupId,
    hospitalId,
    isActive,
    specialityId,
  }: {
    searchquery: string;
    pageNumber: number;
    alphabet?: string;
    groupId?: string;
    hospitalId?: string;
    isActive?: boolean;
    specialityId?: string;
  },
  token: string
): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const response = await superAdminAxiosInstance.get(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBER_LISTS.FETCH_MEMBERS}?search=${searchquery}&user_type=member&IsAccountDeleted=true`,
    config
  )
  return response.data;
};


const deleteAccount = async (payload: any, token: string): Promise<any> => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await superAdminAxiosInstance.delete(
    `${SUPER_ADMIN_API_URL}${SUPER_ADMIN_API_ENDPOINTS.MEMBER_LISTS.FETCH_MEMBERS}`, { ...config, data: payload }
  );
  return response.data;
};

const AccountsService = {
  fetchActiveAccountsData,
  fetchInactiveAccountsData,
  fetchDeletedAccountsData,
  deleteAccount

};

export default AccountsService;
